import { render, staticRenderFns } from "./igt-sidebar-external-link.vue?vue&type=template&id=b0bc8d86&scoped=true&"
import script from "./igt-sidebar-external-link.vue?vue&type=script&lang=js&"
export * from "./igt-sidebar-external-link.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0bc8d86",
  null
  
)

export default component.exports